import { useEffect } from 'react';
import '../assets/css/CustomTopbar.css';
import { openConfirmDialog } from '../components/CustomConfirmDialog';
import { clearLocalStorage } from '../helper/localStorageHelper';
import { ROUTES } from '../routes/Routes';
import { logout } from '../services/adminService';
import { getNavigate } from '../helper/utility';

const CustomTopbar = () => {
  const navigate = getNavigate();

  const handleLogout = async () => {
    openConfirmDialog(
      "Are you sure you want to logout?",
      "Logout",
      "Cancel",
      async () => {
        let response = await logout()
        if (response) {
          clearLocalStorage();
          navigate(ROUTES.LOGIN.path, { replace: true });
        }
      }
    );
  };

  return (
    <div className="custom-topbar-container">
      <div className="custom-topbar-user-info" onClick={() => handleLogout()}>
            <i className="fas fa-sign-out-alt all-small-icon" style={{ color: 'var(--white-color)' }}></i> Logout
      </div>
    </div>
  );
};

export default CustomTopbar;
